import React from 'react';
import InputController from '@/components/inputController/index';
import { PERSONAL_DATA } from '@/constants/personalData';
import FormTemplate from '@/components/formTemplate/index';

function PersonalData({
  control,
  showTitle = true,
  step = null,
  contactDataHidden = false,
}) {
  const {
    TITLE,
    ID,
    DOC_NUMBER,
    NAME,
    LAST_NAME,
    SECOND_SURNAME,
    EMAIL,
    CONTACT_PHONE,
  } = PERSONAL_DATA;
  return (
    <div className="personal-data-container">
      <FormTemplate titleText={showTitle ? TITLE : ''} cyData={ID} step={step}>
        <InputController
          className="personal-data-container__input"
          inputName={DOC_NUMBER.NAME}
          inputId={DOC_NUMBER.ID}
          control={control}
          rules={{
            required: DOC_NUMBER.RULES.REQUIRED,
            pattern: DOC_NUMBER.RULES.PATTERN.DOC_NUMBER_FORMAT,
            validate: (fieldValue) =>
              DOC_NUMBER.RULES.VALIDATE.DOC_NUMBER_FORMAT.checkFunc(
                fieldValue
              ) || DOC_NUMBER.RULES.VALIDATE.DOC_NUMBER_FORMAT.message,
          }}
          label={DOC_NUMBER.LABEL}
        />
        <InputController
          className="personal-data-container__input"
          inputName={NAME.NAME}
          inputId={NAME.ID}
          control={control}
          rules={{
            required: NAME.RULES.REQUIRED,
            pattern: NAME.RULES.PATTERN.NAME_FORMAT,
            validate: (fieldValue) =>
              NAME.RULES.VALIDATE.EMPTY_TEXT.checkFunc(fieldValue) ||
              NAME.RULES.VALIDATE.EMPTY_TEXT.message,
          }}
          label={NAME.LABEL}
        />
        <InputController
          className="personal-data-container__input"
          inputName={LAST_NAME.NAME}
          inputId={LAST_NAME.ID}
          control={control}
          rules={{
            required: LAST_NAME.RULES.REQUIRED,
            pattern: LAST_NAME.RULES.PATTERN.LAST_NAME_FORMAT,
            validate: (fieldValue) =>
              LAST_NAME.RULES.VALIDATE.EMPTY_TEXT.checkFunc(fieldValue) ||
              LAST_NAME.RULES.VALIDATE.EMPTY_TEXT.message,
          }}
          label={LAST_NAME.LABEL}
        />
        <InputController
          className="personal-data-container__input"
          inputName={SECOND_SURNAME.NAME}
          inputId={SECOND_SURNAME.ID}
          control={control}
          rules={{
            required: SECOND_SURNAME.RULES.REQUIRED,
            pattern: SECOND_SURNAME.RULES.PATTERN.SECOND_SURNAME_FORMAT,
            validate: (fieldValue) =>
              SECOND_SURNAME.RULES.VALIDATE.EMPTY_TEXT.checkFunc(fieldValue) ||
              SECOND_SURNAME.RULES.VALIDATE.EMPTY_TEXT.message,
          }}
          label={SECOND_SURNAME.LABEL}
        />
        {!contactDataHidden && (
          <>
            <InputController
              className="personal-data-container__input"
              inputName={EMAIL.NAME}
              inputId={EMAIL.ID}
              control={control}
              inputMode="email"
              rules={{
                required: EMAIL.RULES.REQUIRED,
                pattern: EMAIL.RULES.PATTERN.EMAIL_FORMAT,
                validate: (fieldValue) =>
                  EMAIL.RULES.VALIDATE.EMAIL_DOMAIN.checkFunc(fieldValue) ||
                  EMAIL.RULES.VALIDATE.EMAIL_DOMAIN.message,
              }}
              label={EMAIL.LABEL}
            />
            <InputController
              className="personal-data-container__input--last"
              inputName={CONTACT_PHONE.NAME}
              inputId={CONTACT_PHONE.ID}
              mask={CONTACT_PHONE.MASK}
              control={control}
              inputMode="numeric"
              rules={{
                required: CONTACT_PHONE.RULES.REQUIRED,
                validate: (fieldValue) =>
                  CONTACT_PHONE.RULES.VALIDATE.CONTACT_PHONE_FORMAT.checkFunc(
                    fieldValue
                  ) ||
                  CONTACT_PHONE.RULES.VALIDATE.CONTACT_PHONE_FORMAT.message,
              }}
              label={CONTACT_PHONE.LABEL}
              info={CONTACT_PHONE.INFO}
            />
          </>
        )}
      </FormTemplate>
      <style jsx>
        {`
          .personal-data-container {
            margin-bottom: 12px;
            :global(.personal-data-container__input) {
              margin: 0px 0 8px 0px;
              width: 100%;
            }
            :global(.personal-data-container__input--last) {
              margin: 0px 0 0px 0px;
              width: 100%;
            }
          }
        `}
      </style>
    </div>
  );
}
export default PersonalData;
